import { render } from "./AllProducts.vue?vue&type=template&id=6bc0e448"
import script from "./AllProducts.vue?vue&type=script&lang=js"
export * from "./AllProducts.vue?vue&type=script&lang=js"

import "./AllProducts.vue?vue&type=style&index=0&id=6bc0e448&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__